import { t } from "@redotech/redo-i18n";
import ScalesIcon from "@redotech/redo-icons/scales-02_filled.svg";
import { Step } from "@redotech/redo-return-core-common/return-flow";
import { processingActionFromModel } from "@redotech/redo-return-core-common/return-flow-step-from-model";
import {
  isProcessingActionStepValid,
  ProcessingActionState,
} from "@redotech/redo-return-core-common/return-flow-step-valid";
import { ProcessingActionType } from "@redotech/redo-return-core-common/return-flow/processing-action";
import { STEP_TYPE_NAMES } from "@redotech/redo-return-core-common/return-flow/step-type-names";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import { produce } from "immer";
import * as React from "react";
import { StepType, StepTypeDetailsProps } from "../step";

export const PROCESSING_ACTION = (
  Details: React.ComponentType<StepTypeDetailsProps<ProcessingActionState>>,
): StepType<ProcessingActionState, Step.ProcessingAction> => ({
  Details: (props) => React.createElement(Details, props),
  customTitle: (state) => state.customTitle,
  description: (state) =>
    state.action.type === ProcessingActionType.AssignGrade
      ? t("Assign Grade: {{grade}}", { grade: state.action.grade || "—" })
      : t("Assign Grade"),
  downstream(state) {
    return state.next ? [{ id: state.next }] : [];
  },
  empty: {
    action: { type: ProcessingActionType.AssignGrade, grade: "" },
    scope: "return_item",
  },
  fromModel: (model, id) => processingActionFromModel(model, id),
  Icon: ScalesIcon,
  iconColor: "success",
  layout: () => BlockLayout.FULL,
  maxDownstream: () => 1,
  removeConnection(state, targetStepId) {
    return produce(state, (draft) => {
      if (draft.next === targetStepId) {
        draft.next = undefined;
      }
    });
  },
  stepDeleted(state, stepId) {
    return produce(state, (draft) => {
      if (draft.next === stepId) {
        draft.next = undefined;
      }
    });
  },
  title: STEP_TYPE_NAMES[Step.PROCESSING_ACTION],
  toModel(state, id) {
    return {
      type: Step.PROCESSING_ACTION,
      action: state.action,
      customTitle: state.customTitle,
      next: state.next ? id(state.next) : null,
      scope: state.scope,
    };
  },
  updateConnection(state, handleIndex, targetStepId) {
    if (handleIndex !== 0) {
      throw new Error(
        `Invalid handle index ${handleIndex} for processing action step`,
      );
    }
    return produce(state, (draft) => {
      draft.next = targetStepId;
    });
  },
  valid: (state) => isProcessingActionStepValid(state).valid,
});
